import { Link } from 'react-router-dom';

export default function EmptyState({
  icon: Icon,
  title,
  description,
  primaryAction,
  secondaryAction,
  helper,
}) {
  return (
    <div className="flex flex-col items-center py-14 px-6 text-center">
      {Icon && <Icon className="text-5xl text-gray-200 mb-3" />}
      <p className="text-sm font-semibold text-gray-500 mb-1">{title}</p>
      {description && <p className="text-xs text-gray-400 mb-4 max-w-xs">{description}</p>}

      {(primaryAction || secondaryAction) && (
        <div className="flex flex-wrap items-center justify-center gap-3 mb-3">
          {primaryAction && (
            primaryAction.to ? (
              <Link
                to={primaryAction.to}
                className="flex items-center gap-1.5 text-primary text-xs font-semibold hover:underline"
              >
                {primaryAction.icon && <primaryAction.icon />}
                {primaryAction.label}
              </Link>
            ) : (
              <button
                onClick={primaryAction.onClick}
                className="flex items-center gap-1.5 text-primary text-xs font-semibold hover:underline"
              >
                {primaryAction.icon && <primaryAction.icon />}
                {primaryAction.label}
              </button>
            )
          )}
          {secondaryAction && (
            secondaryAction.to ? (
              <Link
                to={secondaryAction.to}
                className="flex items-center gap-1.5 text-gray-400 text-xs hover:underline"
              >
                {secondaryAction.icon && <secondaryAction.icon />}
                {secondaryAction.label}
              </Link>
            ) : (
              <button
                onClick={secondaryAction.onClick}
                className="flex items-center gap-1.5 text-gray-400 text-xs hover:underline"
              >
                {secondaryAction.icon && <secondaryAction.icon />}
                {secondaryAction.label}
              </button>
            )
          )}
        </div>
      )}

      {helper && (
        <p className="text-[11px] text-gray-300 max-w-xs">{helper}</p>
      )}
    </div>
  );
}
